import { Spin } from "antd";

export default function LoadingModal() {
    return <div className="absolute top-0 left-0  h-full w-full bg-white bg-opacity-70 flex items-center justify-center">
        <Spin size="large" />
    </div>
}